<template>
  <div class="pb-2 max-h-full h-full">
    <div class="max-h-full h-full">
      <div class="flex min-h-full h-full overflow-hidden">
        <div class="flex-grow max-h-full overflow-auto py-3">
          <div class="px-5">
            <VariableSelect v-model="html.variable" label="Assign to Variable" class="flex-grow" :filter-data-type="['Text']" @update:modelValue="emitPayload" />
            <PhraseEditor v-model="html.file_name" :items="variables" label="File Name" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
            <FormSelect v-model="html.template" :options="templates" default-reducer append-to-body label="Template" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
            <VariableSelect v-model="html.data" multiple :items="variables" label="Template Variables" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
            <div class="mt-3 w-full">
              <label class="block text-12 mb-1">Inject Content Using AI</label>
              <Toggle v-model="html.auto_inject" @update:modelValue="emitPayload" />
            </div>
            <FormSelect
              v-if="html.auto_inject"
              :label="$t('evaluate.provider')"
              v-model="html.provider"
              :options="providers"
              :selectable="(option) => !option.disabled"
              :reduce="(option) => option.value"
              class="w-full mt-3"
              @update:modelValue="onProviderChange"
            />
            <FormSelect
              v-if="html.auto_inject"
              :label="$t('evaluate.model')"
              v-model="html.model"
              :options="models"
              append-to-body
              :reduce="(option) => option.value"
              class="w-full mt-3"
              @update:modelValue="emitPayload"
            />
            <VariableSelect
              v-if="html.auto_inject"
              v-model="html.content"
              :append-to-body="false"
              :filterDataType="['Text']"
              label="Text Content for AI"
              @update:modelValue="emitPayload"
              multiple
              class="w-full mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import debounce from '../../../helpers/debounce';
import uuidv4 from '../../../helpers/uuid';
import EvaluateItemsConfig from './EvaluateItemsConfig';

export default {
  name: 'DocumentHTMLConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      html: structuredClone(EvaluateItemsConfig['document-html'].payload),
    };
  },
  created() {
    this.html = { ...this.html, ...JSON.parse(JSON.stringify(this.item.payload)) };
  },
  computed: {
    ...mapState(['projectData', 'availableAIProviders']),
    ...mapGetters(['getProjectTemplates', 'getProjectAIProviderOptions']),
    templates() {
      return Object.keys(this.getProjectTemplates()).map((key) => ({
        label: this.getProjectTemplates()[key].name,
        value: key,
      }));
    },
    payload() {
      return {
        id: this.item.id,
        type: this.item.type,
        payload: this.html,
      };
    },
    projectId() {
      return this.$route.params.projectId;
    },
    variables() {
      let variables = [];
      if (this.projectId && Object.keys(this.projectData).length) {
        variables = Object.keys(this.projectData?.[this.projectId]?.variables || {}).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) || [];
      }
      variables = variables.map((variable) => ({
        id: uuidv4(),
        value: variable,
      }));
      return variables;
    },
    providers() {
      return this.getProjectAIProviderOptions();
    },
    models() {
      if (!this.html.provider) return [];
      return Object.values(this.availableAIProviders[this.html.provider].models).map((item) => ({ label: `<b>${item.name}</b> - <i class="text-11">Cost: ${item.cost}</i>`, value: item.model }));
    },
  },
  methods: {
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.$emit('update', structuredClone(this.payload));
    }, 300),
    onProviderChange() {
      this.html.model = '';
    },
  },
};
</script>
